const MAX_ARRIVAL_PHOTO_SIZE = 20 * 1024 * 1024;
const ARRIVAL_PHOTO_TYPES = new Set(["image/jpeg", "image/png", "image/webp"]);

const getArrivalPhotoError = (file) => {
    if (!file) return "请选择一张现场照片";
    if (!Number.isFinite(Number(file.size)) || Number(file.size) <= 0) return "现场照片不能为空";
    if (!ARRIVAL_PHOTO_TYPES.has(String(file.type || "").toLowerCase())) return "现场照片仅支持 JPG、PNG 或 WebP 格式";
    if (Number(file.size) > MAX_ARRIVAL_PHOTO_SIZE) return "现场照片不能超过 20 MiB";
    return "";
};

const buildArrivalSubmission = (file, FormDataConstructor = FormData) => {
    const error = getArrivalPhotoError(file);
    if (error) throw new Error(error);
    const formData = new FormDataConstructor();
    formData.append("photo", file);
    return formData;
};

module.exports = {
    MAX_ARRIVAL_PHOTO_SIZE,
    buildArrivalSubmission,
    getArrivalPhotoError,
};
